import { Scenario, ScenarioType, Steps } from '../state/interfaces'
import { emailAddressPageGo } from './email-page-go-steps'

export const emailPageGoInternetScenarioA: Scenario = {
  id: 'email-page-go-internet-a',
  initialStep: Steps.EMAIL_ADDRESS,
  type: ScenarioType.EMAIL_PAGE_GO_INTERNET,
  version: '1',
  milestones: [emailAddressPageGo.id],
  steps: [emailAddressPageGo],
  weight: 1,
}

export const emailPageGoMobileScenarioA: Scenario = {
  id: 'email-page-go-mobile-a',
  initialStep: Steps.EMAIL_ADDRESS,
  type: ScenarioType.EMAIL_PAGE_GO_MOBILE,
  version: '1',
  milestones: [emailAddressPageGo.id],
  steps: [emailAddressPageGo],
  weight: 1,
}
